/**
 * 자료이관 모듈 메뉴 (MIG_)
 * hrMenuConfig 의 TOP/LEFT 에 병합한다.
 * 더존 G20 분개장·기초이월 → ERP 전표 컨버전. 예실대비·계약현황은 후속.
 */
export const MIG_TOP_MENUS = [
  { id: '900', label: '자료이관', icon: 'transfer', iconSrc: null, menuNo: '900', progId: 'MIG' },
];

const leaf = (id, upper, label, screenId, menuType, url, comp, extra = {}) => ({
  id,
  label,
  menuNo: id,
  upperMenuId: upper,
  progId: screenId,
  screenId,
  menuType,
  url,
  componentPath: `pages/migrate/${comp}`,
  ...extra,
});

const dir = (id, upper, label, children) => ({
  id,
  label,
  menuNo: id,
  upperMenuId: upper,
  url: 'dir',
  children,
});

export const MIG_LEFT_MENUS = {
  '900': [
    {
      id: '900',
      label: '자료이관',
      menuNo: '900',
      upperMenuId: '0',
      url: 'dir',
      children: [
        dir('910', '900', '더존G20', [
          leaf('911', '910', '분개장', 'MIG_G20_JOURNAL', 'inquiry', '/migrate/g20-journal', 'G20JournalConvert'),
          leaf('912', '910', '기초이월자료', 'MIG_G20_FWD', 'inquiry', '/migrate/g20-fwd', 'G20FwdConvert'),
        ]),
      ],
    },
  ],
};
